/* Identical file in Marketing & NL-CMS. If you modify this file, make the same changes there,
and vice-versa, unless changes should be specific to this project, then remove this comment. */
import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

interface TextAreaFieldProps {
  autoComplete?: string;
  className?: string;
  disabled?: boolean;
  hint?: string;
  label?: string;
  maxCharCount?: number;
  minRows?: number;
  name: string;
  placeholder?: string;
  rows?: number;
}

const TextAreaField = (props: TextAreaFieldProps) => {
  const { label, name, hint } = props;
  const { maxCharCount, ...inputProps } = props;
  const [field, meta] = useField(name);
  const [charCount, setCharCount] = useState(field.value?.length || 0);

  useEffect(() => {
    if (maxCharCount) {
      setCharCount(field.value?.length || 0);
    }
  }, [field.value, maxCharCount]);

  return (
    <div className="TextAreaField form-group">
      {label && (
        <label className="input-label" htmlFor={name}>
          {label}
        </label>
      )}
      {hint && <div className="hint">{hint}</div>}
      <div className="forum-group-content">
        <TextareaAutosize
          className={`form-control${meta.error ? ' is-invalid' : ''}`}
          id={name}
          {...inputProps}
          {...field}
        />
        {maxCharCount && (
          <div className={`max-limit ${meta.touched && meta.error ? '--invalid' : ''}`}>
            ({charCount}/{maxCharCount})
          </div>
        )}
        {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
      </div>
    </div>
  );
};

export default TextAreaField;
